<template>
  <a href="javascript:void(0)" @click="onClick($event)">
    <slot />
  </a>
</template>

<script>
import {openSignup, openSignupAndPreserveUrl} from "@/helpers";
export default {
  name: "LinkToSignup",
  props: {
    preserve: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onClick(ev) {
      if (this.preserve) {
        openSignupAndPreserveUrl(ev);
      } else {
        openSignup(ev);
      }
    }
  }
}
</script>

<style scoped>

</style>
